import ko from "knockout";
import $ from "jquery";
/*import * as Ladda from 'ladda';*/

window.ko = ko;
window.$ = window.jQuery = $;
/*window.Ladda = Ladda;*/